<template>
	<li class="line-item on">
		<i class="icon-hook"></i><slot></slot>
	</li>
</template>
<script>
export default {
  name: "lineItem",
  mounted() {
    var linenew = document.querySelectorAll(".line-item")[0].className ="line-item new";
    var l = document.querySelectorAll(".line-item");
    for (let i = 0; i < l.length; i++) {
      if (i > 2) {
        l[i].className = "line-item on hidden";
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/timeline/lineItem.vue